// extracted by mini-css-extract-plugin
export default {"gameScore":"Score_gameScore__8ks1K","gameOver":"Score_gameOver__fTi6G","gameWon":"Score_gameWon__5WA5i"};